export default function valueEmpty(myValue) {
  if(!myValue)
  {
    myValue = "";
  }
  return myValue;
}